export const ProjConstants = {
  LOCATION_HIE: {
      DEFAULT_HIE: ['state', 'district', 'mandal', 'village', 'borewell'],
      GEO: ['state', 'district', 'mandal', 'college','student']
    },
    LOCATION_CONSTANT_OPTIONS: {
      url: ['entityName', 'entityId'],
      dataType: 'FINALLOCATION',
      child: 'district',
      jsonkey: 'entityName',
      name: 'District'
    }
}